export enum HistorySalesStatusText {
	bought = 'Оплачено',
	canceled = 'Отменен'
}

export enum HistorySalesStatusColor {
	bought = '#24D321',
	canceled = '#ED4141'
}
